import Vue, { Component } from 'vue';

export const withWrapper = (wrapper: Component) => (component: Component) =>
  Vue.component('WithWrapper', {
    render: (h) => h(wrapper, {}, [h(component)]),
  });
